import { Helmet } from "react-helmet-async";
import profileImage from "../../Images/bannerlogin.png";

const SeoMetaData = ({ data }) => {
    let location = '';
    if (data?.location) {
        location += data?.location + ', ';
    }
    if (data?.emirate) {
        location += data?.emirate + ', ';
    }
    if (data?.countryName) {
        location += data?.countryName;
    }
    return (
        <Helmet>
            <title>{`${data?.companyName} | ${data?.TypeOfCompany || data?.companyTypeName} | NeooSearch`}</title>
            <meta
                name="description"
                content={`${data?.companyName}, an ${data?.TypeOfCompany || data?.companyTypeName} company in ${location} offering ${data?.businessProductCat?.map(s => s).join(', ') || 'services'}   `}
                data-rh="true"
            />

            <meta property="og:title" content={`${data?.companyName} | ${data?.TypeOfCompany || data?.companyTypeName} | NeooSearch`} data-rh="true" />
            <meta property="og:description" content={`${data?.companyName}, an ${data?.TypeOfCompany || data?.companyTypeName} company in ${location} offering ${data?.businessProductCat?.map(s => s).join(', ') || 'services'}`} data-rh="true" />
            <meta property="og:image" content={data?.businesBanner || profileImage} data-rh="true" />
            <meta property="og:url" content={process.env.REACT_APP_APPLICATION_URL + "/businesspage/" + data?.companySlug} data-rh="true" />
            <meta property="og:type" content="website" data-rh="true" />
            <meta property="og:site_name" content={process.env.REACT_APP_APPLICATION_URL} data-rh="true" />
            <link rel="canonical" href={process.env.REACT_APP_APPLICATION_URL + "/businesspage/" + data?.companySlug} />
            <meta name="keywords" content={data?.businessProductkeywords || "default, keywords"} data-rh="true" />

            <meta name="twitter:card" content="summary_large_image" data-rh="true" />
            <meta name="twitter:title" content={`${data?.companyName} | ${data?.TypeOfCompany || data?.companyTypeName} | NeooSearch`} data-rh="true" />
            <meta name="twitter:description" content={`${data?.companyName}, an ${data?.TypeOfCompany || data?.companyTypeName} company in ${location} offering ${data?.businessProductCat?.map(s => s).join(', ') || 'services'}`} data-rh="true" />
            <meta name="twitter:image" content={data?.businesBanner || profileImage} data-rh="true" />
            <meta name="twitter:image:alt" content={`Banner of ${data?.companyName}`} data-rh="true" />
        </Helmet>
    );
};
export default SeoMetaData;